export const ShowWhenTrue: React.FC<{
  when: boolean
  children: React.ReactNode
}> = ({ when, children }) => {
  return when ? <>{children}</> : null
}

export const ShowWhenFalse: React.FC<{
  when: boolean
  children: React.ReactNode
}> = ({ when, children }) => {
  return !when ? <>{children}</> : null
}

export const HideWhenTrue: React.FC<{
  when: boolean
  children: React.ReactNode
}> = ({ when, children }) => {
  return when ? null : <>{children}</>
}

export const HideWhenFalse: React.FC<{
  when: boolean
  children: React.ReactNode
}> = ({ when, children }) => {
  return !when ? null : <>{children}</>
}
